import React, { useEffect, useRef } from 'react';
import type { RefObject } from 'react';
import { useLocation } from 'react-router-dom';
import { site } from '../../data/site';
import { programLinks, schoolLinks } from '../../data/navigation';
import { ButtonLink } from '../ui/ButtonLink';
interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  toggleRef: RefObject<HTMLButtonElement>;
}
export function MobileMenu({
  open,
  onClose,
  toggleRef
}: MobileMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const pathname = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
  useEffect(() => {
    if (!open) return;
    menuRef.current?.querySelector<HTMLAnchorElement>('a')?.focus({
      preventScroll: true
    });
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
        toggleRef.current?.focus();
      }
      if (event.key === 'Tab') {
        const nodes = menuRef.current?.querySelectorAll<HTMLElement>('a, button');
        if (!nodes?.length) return;
        const first = nodes[0],
          last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', onKey);
    const previous = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = previous;
    };
  }, [open, onClose, toggleRef]);
  if (!open) return null;
  const groups = [{
    title: 'Explore Bates',
    links: [{
      label: 'Home',
      href: '/'
    }, {
      label: 'Class schedule',
      href: '/schedule'
    }, {
      label: 'Our coaches',
      href: '/instructors'
    }]
  }, {
    title: 'Programs',
    links: programLinks
  }, {
    title: 'More info',
    links: schoolLinks
  }];
  return <div ref={menuRef} id="mobile-menu" role="dialog" aria-modal="true" aria-label="Site navigation" className="absolute inset-x-0 top-full max-h-[calc(100dvh-77px)] overflow-y-auto border-t border-white/10 bg-ink sm:max-h-[calc(100dvh-113px)] lg:hidden" data-id="element-415" data-mp="16oihac0725yy">
    <nav aria-label="Mobile" className="px-5 py-6 sm:px-8" data-id="element-416" data-mp="3cnzwk8w645vt">
      <div className="space-y-6" data-id="element-417" data-mp="37one00cbxkz1">{groups.map(group => <div key={group.title} data-id="element-418" data-mp="37pompy5vhvdl">
        <h2 className="mb-2 text-xs font-semibold uppercase tracking-[0.15em] text-white/45" data-id="element-419" data-mp="37mkdunhgqbgl">{group.title}</h2>
        <ul data-id="element-420" data-mp="2jwq1e7122owv">{group.links.map(link => <li key={link.href} data-id="element-421" data-mp="2f0hrb81ptlwk"><a href={link.href} onClick={onClose} aria-current={pathname === link.href ? 'page' : undefined} className={`flex min-h-[44px] items-center border-b border-white/10 py-2 text-base ${pathname === link.href ? 'text-sun' : 'text-white/85'}`} data-id="element-422" data-mp="2f10zhx1kcvxe">{link.label}</a></li>)}</ul>
      </div>)}</div>
      <ButtonLink href="/free-trial-class" onClick={onClose} className="mt-6 w-full" data-id="element-423" data-mp="217t6c0xu3sdl">Book a Free Trial Class</ButtonLink>
      <a href={site.phoneHref} className="mt-3 flex min-h-[44px] items-center justify-center text-white/75" data-id="element-424" data-mp="1w8ov74rcnkkm">{site.phoneDisplay}</a>
      <button type="button" onClick={() => {
        onClose();
        toggleRef.current?.focus();
      }} className="mt-2 min-h-[44px] w-full rounded border border-white/30 text-sm" data-id="element-425" data-mp="bpmj693n6awc">Close menu</button>
    </nav>
  </div>;
}